<script lang="ts" setup>
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner.vue";

defineProps<{
  text?: string;
}>();
</script>

<template>
  <div class="loading-overlay">
    <LoadingSpinner />
    <p
      v-if="text"
      class="loading-overlay--text"
    >
      {{ text }}
    </p>
  </div>
</template>

<style scoped>
@import "LoadingOverlay.css";
</style>
